// extracted by mini-css-extract-plugin
export default {"item":"ClosureListItem_item__J8JFQ","icon":"ClosureListItem_icon__5WWlU","title":"ClosureListItem_title__7tPif","timestamp":"ClosureListItem_timestamp__4Q9h9"};